/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type musingsQueryVariables = {
    postId: string;
};
export type musingsQueryResponse = {
    readonly blog: {
        readonly sys: {
            readonly firstPublishedAt: string | null;
        };
        readonly title: string | null;
        readonly author: {
            readonly fullName?: string | null;
        } | null;
        readonly blogContent: {
            readonly json: string;
        } | null;
    } | null;
};
export type musingsQuery = {
    readonly response: musingsQueryResponse;
    readonly variables: musingsQueryVariables;
};



/*
query musingsQuery(
  $postId: String!
) {
  blog(id: $postId) {
    sys {
      firstPublishedAt
    }
    title
    author {
      __typename
      ... on Author {
        fullName
      }
    }
    blogContent {
      json
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "postId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstPublishedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BlogBlogContent",
  "kind": "LinkedField",
  "name": "blogContent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "json",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "musingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Blog",
        "kind": "LinkedField",
        "name": "blog",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "musingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Blog",
        "kind": "LinkedField",
        "name": "blog",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5918a0a2e26f7aa8417fa7be35f0d1bd",
    "id": null,
    "metadata": {},
    "name": "musingsQuery",
    "operationKind": "query",
    "text": "query musingsQuery(\n  $postId: String!\n) {\n  blog(id: $postId) {\n    sys {\n      firstPublishedAt\n    }\n    title\n    author {\n      __typename\n      ... on Author {\n        fullName\n      }\n    }\n    blogContent {\n      json\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '58a5266103449c2715d8abae8a0615f7';
export default node;
